import axios from 'axios';
import { getMicrocredentialsTaskModule, MICROCREDENTIALS_TASK_MODES } from '../config/microcredentialsTaskModules';

function resolveModuleConfig(mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   return getMicrocredentialsTaskModule(mode);
}

export async function listStudentTaskSubjectGroups(params = {}, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.get(`${moduleConfig.studentBase}/studentsubjectgroup`, {
      params: {
         id: params.id ?? params.userId ?? params.userid ?? null,
         task_type: moduleConfig.taskType,
      },
   });
   return response.data;
}

export async function listStudentTasks(params = {}, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.get(`${moduleConfig.studentBase}/listperstudent`, {
      params: {
         id: params.id ?? params.userId ?? params.userid ?? null,
         s: params.subject ?? params.s ?? '',
         su: params.submitted ?? params.su ?? false,
         task_type: moduleConfig.taskType,
      },
   });
   return response.data;
}

export async function getStudentTaskInfo(id, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.get(`${moduleConfig.studentBase}/info`, {
      params: {
         id,
         task_type: moduleConfig.taskType,
      },
   });
   return response.data;
}

export async function submitStudentTask(payload, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.post(`${moduleConfig.studentBase}/submitperformancetask`, {
      ...payload,
      Task_type: payload?.Task_type ?? moduleConfig.taskType,
   });
   return response.data;
}

export async function unsubmitStudentTask(id, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.post(`${moduleConfig.studentBase}/unsubmitperformancetask`, null, {
      params: {
         id,
         task_type: moduleConfig.taskType,
      },
   });
   return response.data;
}

export async function listStudentTaskSubmissions(params = {}, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.get(`${moduleConfig.studentBase}/v2/studentlist`, {
      params: {
         id: params.id ?? params.homework_id ?? params.homeworkID ?? params.taskId ?? null,
         performance_task_id: params.performance_task_id ?? params.performanceTaskId ?? params.taskId ?? params.id ?? null,
         task_id: params.task_id ?? params.taskId ?? params.id ?? null,
         level: params.level ?? params.levelID ?? null,
         type: params.type ?? 'microcredential',
         assignment_id: params.assignment_id ?? params.assignmentId ?? params.assignmentID ?? null,
         mcpta_id: params.mcpta_id ?? params.assignmentId ?? params.assignmentID ?? null,
         performance_task_assignment_id: params.performance_task_assignment_id ?? params.assignmentId ?? params.assignmentID ?? null,
         assigned_by: params.assigned_by ?? params.assignedBy ?? params.assignedById ?? null,
         task_type: moduleConfig.taskType,
      },
   });
   return response.data;
}

export async function addStudentTaskEvaluation(payload, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.post(`${moduleConfig.studentBase}/addevaluation`, {
      ...payload,
      Task_type: payload?.Task_type ?? moduleConfig.taskType,
   });
   return response.data;
}

export async function removeStudentTaskEvaluation(id, mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   const moduleConfig = resolveModuleConfig(mode);
   const response = await axios.post(`${moduleConfig.studentBase}/removeevaluation`, null, {
      params: {
         id,
         task_type: moduleConfig.taskType,
      },
   });
   return response.data;
}
